export const DEFAULT_MODEL = "openai:gpt-4.1-mini-2025-04-14"
export const DEFAULT_TEXT_JUDGE_MODEL = "coval_judge"
